import { css, Theme } from '@emotion/react'

export const container = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 100%;
  max-width: 1190px;
  padding: 31px 24px;
  background: ${theme.backgrounds.backgroundFour};
`

export const title = css`
  font-weight: 700;
`

export const tabs = css`
  margin: 40px 0 24px;
`
